const voiceCommunityRoom = {
  // 语音社区 用户查询房间详情信息
  roomDetail: `/authApi/voiceforum/v1/roomDetail`,
  // 频道管理 根据房间ID获取房间内的分组、频道信息视图
  roomView: `/authApi/voiceforum/v1/roomView`,
  // 频道管理 创建分组
  createGroup: `/authApi/voiceforum/v1/createGroup`,
  // 频道管理 创建频道/子频道
  createChannel: `/authApi/voiceforum/v1/createChannel`,
  // 频道管理 删除分组
  deleteGroup: `/authApi/voiceforum/v1/deleteGroup`,
  // 频道管理 批量删除频道/子频道
  deleteChannels: `/authApi/voiceforum/v1/delete/channels`,
  // 频道管理 编辑分组
  editGroup: `/authApi/voiceforum/v1/editGroup`,
  // 频道管理 频道/子频道编辑
  editChannel: `/authApi/voiceforum/v1/editChannel`,
  // 频道管理 获取频道/子频道信息
  channel: `/authApi/voiceforum/v1/channel`,
  // 查询房间或频道权限开关详情
  groupDetail: `/authApi/voiceforum/permission/group/detail`,
  // 查询权限组列表
  groupList: `/authApi/voiceforum/permission/group/list`,
  // 更新权限组
  groupUpdate: `/authApi/voiceforum/permission/group/update`,
  // 同步频道权限
  channelSync: `/authApi/voiceforum/permission/channel/sync`,
  // 删除权限组
  groupDelete: `/authApi/voiceforum/permission/group/delete`,
  // 语音社区 获取申请加入房间用户成员
  applyMemberList: `/authApi/voiceforum/v1/applyMemberList`,
  // 语音社区 申请加入非公开房间审核
  approval: `/authApi/voiceforum/v1/joinRoom/approval`,
  // 语音社区 申请加入非公开房间(需要审批)
  applyJoinRoom: `/authApi/voiceforum/v1/applyJoinRoom`,
  // 还原权限组默认设置
  revert: `/authApi/voiceforum/permission/member/revert`,
  // 创建权限组
  groupCreate: `/authApi/voiceforum/permission/group/create`,
  // 房间设置 房间基础设置
  roomBasicInfo: `/authApi/voiceforum/v1/roomBasicInfo`,
  // 房间基础设置  房间资料信息保存
  saveRoomBasicMaterial: `/authApi/voiceforum/v1/saveRoomBasicMaterial`,
  // 语音社区 获取房间成员列表
  roomMemberList: `/authApi/voiceforum/permission/group/member/search`,
  // 查询当前权限组成员
  groupMember: `/authApi/voiceforum/permission/group/member`,
  // 批量给用户添加管理员权限
  addBatch: `/authApi/voiceforum/permission/member/add/batch`,
  // 移除管理员权限
  removeBatch: `/authApi/voiceforum/permission/member/remove/batch`,
  // 房间设置 房间基础设置 获取文字频道下拉列表
  textChannelList: `/authApi/voiceforum/v1/channelList`,
  // 房间基础设置  默认频道信息保存 仅pc端有
  saveRoomDefaultChannel: `/authApi/voiceforum/v1/saveRoomDefaultChannel`,
  // 获取禁言时间列表
  muteTime: `/authApi/voiceforum/chat/mute/time`,
  // 批量禁言用户
  muteBatch: `/authApi/voiceforum/chat/mute/batch`,
  // 批量将用户踢出房间
  roomBatch: `/authApi/voiceforum/chat/kick/room/batch`,
  // 解除用户禁言
  unmute: `/authApi/voiceforum/chat/unmute`,
  // 房间基础设置 再次进入频道、再次上麦、再次进入房间保存
  saveEnterRoomInfo: `/authApi/voiceforum/v1/saveEnterRoomInfo`,
  // 房间基础设置 频道欢迎信息保存
  saveRoomWelcomeInfo: `/authApi/voiceforum/v1/saveRoomWelcomeInfo`,
  // 查询封停原因列表
  reportReason: `/authApi/voiceforum/chat/report/reason`,
  // 举报消息
  chatReport: `/authApi/voiceforum/chat/report`,
  // 语音社区 获取分享链接
  shareUrl: `/authApi/voiceforum/v1/shareUrl/generate`,
  // 获取房间分组列表
  roomGroupList: `/authApi/voiceforum/v1/roomGroupList`,
  // 语音社区 获取房间成员列表
  onLineRoomMemberList: `/authApi/voiceforum/v1/roomMemberList`,
  // 频道管理展示使用 获取房间下所以得分组、频道简单信息
  roomChannelList: `/authApi/voiceforum/v1/roomChannelList`,
  // 语音社区 分组移动
  groupTransfer: `/authApi/voiceforum/v1/group/transfer`,
  // 频道管理 频道转移到指定分组 pc端使用
  pcChannelTransfer: `/authApi/voiceforum/v1/pcChannel/transfer`,
  // 主页面 频道排序 pc端使用
  pcChannelSort: `/authApi/voiceforum/v1/pcChannel/sort`,
  // 将用户踢出频道
  kickChannel: `/authApi/voiceforum/chat/kick/channel`,
  // 语音社区 退出房间
  existRoom: `/authApi/voiceforum/v1/existRoom`,
  // 进入频道验证频道密码
  checkChannelPassword: `/authApi/voiceforum/v1/checkChannelPassword`,
  // 获取游戏启动信息
  gameInstall: `/authApi/box/v1/get-game-install-info`,
  // 撤回消息
  revoke: `/authApi/voiceforum/chat/revoke`,
  // 语音社区 解散房间
  disbandRoom: `/authApi/voiceforum/v1/disbandRoom`,
  // 加入频道前检查
  joinCheck: `/authApi/voiceforum/v1/channel/joinCheck`,
  // 检查是否允许上传图片
  uploadPicture: `/authApi/voiceforum/permission/check/uploadPicture`,
  // 检查是否允许上传文件
  uploadFile: `/authApi/voiceforum/permission/check/uploadFile`
};

export default voiceCommunityRoom;
